module.exports = "<div #map id=\"map\"></div>\n"